export enum QuestionnaireApiType {
  V1 = 'V1',
  V2 = 'V2',
}

export const QuestionnaireApiValues = Object.keys(QuestionnaireApiType);
